import CustomDateField from "components/CustomDateField";
import moment from "moment";
import {
  ResourceContextProvider,
  List,
  Datagrid,
  TextField,
  ReferenceField,
  FunctionField,
  Filter,
  DateInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";
import { SchoolIdSelected } from "utils/tools";

const NotTakingReportTable = () => {
  const NotTakingFilter = (props: any) => {
    return (
      <Filter {...props}>
        <DateInput source="Date" label="Date" alwaysOn />
        <ReferenceInput
          source="BusScheduleId"
          label="Wave Name"
          reference="busSchedules"
          alwaysOn
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
      </Filter>
    );
  };

  return (
    <ResourceContextProvider value="notTakingReports">
      <List
        basePath="/notTakingReports"
        actions={null}
        exporter={false}
        hasCreate={false}
        filters={<NotTakingFilter />}
        filterDefaultValues={{
          Date: `${moment().format("Y-MM-DD")}`,
        }}
        sort={{ field: "date", order: "DESC" }}
        bulkActionButtons={false}
        title="Not Takings"
      >
        <Datagrid>
          <ReferenceField
            source="studentId"
            label="Student"
            reference="students"
            link={false}
          >
            <FunctionField
              render={(record: any) => `${record.firstName} ${record.lastName}`}
            />
          </ReferenceField>
          <ReferenceField
            source="busSchedulePlanId"
            label="Wave Name"
            reference="busSchedulePlans"
            link={false}
          >
            <ReferenceField
              source="busScheduleId"
              reference="busSchedules"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </ReferenceField>
          <TextField source="routeName" emptyText="-" />
          <CustomDateField source="date" />
        </Datagrid>
      </List>
    </ResourceContextProvider>
  );
};

export default NotTakingReportTable;
